import React from "react";
import AlabamaIIHS from "../referralComponents/AlabamaIIHS";
import AlabamaTFC from "../referralComponents/AlabamaTFC";
import ColoradoMGTS from "../referralComponents/ColoradoMGTS";
import IndianaReferral from "../referralComponents/IndianaReferral";
import KentuckyReferral from "../referralComponents/KentuckyReferral";
import LimaBehavioralHealth from "../referralComponents/LimaBehavioralHealth";
import MCRScreener from "../referralComponents/MCRScreener";
import CincinnatiEFIN from "../referralComponents/CincinnatiEFIN";
import IndianaOP from "../referralComponents/IndianaOP";
import SCTFCReferral from "../referralComponents/SCTFCReferral";
import SoutherINKinship from "../referralComponents/SoutherINKinship";
import LBHEmp from "../referralComponents/LBHEmp";
import SCFRCPS from "../referralComponents/SCFRCPS";
import SCPP from "../referralComponents/SCPP";
import KYHIFI from "../referralComponents/KYHIFI";
import JAH from "../referralComponents/JAH";

function ReferralCustomRender({ data, setData, handleSave }) {
  const name =
    data &&
    data.DynamicFields &&
    data.DynamicFields.results &&
    data.DynamicFields.results.ReferralConfig &&
    data.DynamicFields.results.ReferralConfig.value
      ? data.DynamicFields.results.ReferralConfig.value
      : "No Custom Component";

  const handleDynamicDataChange = ({ currentTarget: input }) => {
    console.log("dynamic input: ", input, input.name, input.value);
    console.log("dynamic value: ", input.value);
    const obj = { ...data };

    obj.DynamicFields.results[input.name] =
      input.type === "checkbox" ? input.checked.toString() : input.value;
    setData(obj);
  };

  switch (name) {
    case "LimaBehavioral":
      return (
        <LimaBehavioralHealth
          data={data}
          handleChange={handleDynamicDataChange}
          handleSave={handleSave}
        ></LimaBehavioralHealth>
      );
    case "IndianaReferral":
      return (
        <IndianaReferral
          data={data}
          handleChange={handleDynamicDataChange}
          handleSave={handleSave}
        ></IndianaReferral>
      );
    case "KentuckyReferral":
      return (
        <KentuckyReferral
          data={data}
          handleChange={handleDynamicDataChange}
          handleSave={handleSave}
        ></KentuckyReferral>
      );
    case "KYHIFI":
      return (
        <KYHIFI
          data={data}
          handleChange={handleDynamicDataChange}
          handleSave={handleSave}
        ></KYHIFI>
      );
    case "AlabamaTFC":
      return (
        <AlabamaTFC
          data={data}
          handleChange={handleDynamicDataChange}
          handleSave={handleSave}
        ></AlabamaTFC>
      );
    case "AlabamaIIHS":
      return (
        <AlabamaIIHS
          data={data}
          handleChange={handleDynamicDataChange}
          handleSave={handleSave}
        ></AlabamaIIHS>
      );
    case "ColoradoMGTS":
      return (
        <ColoradoMGTS
          data={data}
          handleChange={handleDynamicDataChange}
          handleSave={handleSave}
        ></ColoradoMGTS>
      );
    case "MCRScreener":
      return (
        <MCRScreener
          data={data}
          handleChange={handleDynamicDataChange}
          handleSave={handleSave}
        ></MCRScreener>
      );
    case "CincinnatiEFIN":
      return (
        <CincinnatiEFIN
          data={data}
          handleChange={handleDynamicDataChange}
          handleSave={handleSave}
        ></CincinnatiEFIN>
      );
    case "IndianaOP":
      return (
        <IndianaOP
          data={data}
          handleChange={handleDynamicDataChange}
          handleSave={handleSave}
        ></IndianaOP>
      );
    case "SCTFCReferral":
      return (
        <SCTFCReferral
          data={data}
          handleChange={handleDynamicDataChange}
          handleSave={handleSave}
        ></SCTFCReferral>
      );
    case "SCPP":
      return (
        <SCPP
          data={data}
          handleChange={handleDynamicDataChange}
          handleSave={handleSave}
        ></SCPP>
      );
    case "SCFRCPS":
      return (
        <SCFRCPS
          data={data}
          handleChange={handleDynamicDataChange}
          handleSave={handleSave}
        ></SCFRCPS>
      );
    case "SoutherINKinship":
      return (
        <SoutherINKinship
          data={data}
          handleChange={handleDynamicDataChange}
          handleSave={handleSave}
        ></SoutherINKinship>
      );
    case "LBHEmp":
      return (
        <LBHEmp
          data={data}
          handleChange={handleDynamicDataChange}
          handleSave={handleSave}
        ></LBHEmp>
      );
    case "JAH":
      return (
        <JAH
          data={data}
          handleChange={handleDynamicDataChange}
          handleSave={handleSave}
        />
      );
    default:
      return <div>No Custom Referral configured</div>;
  }
}

export default ReferralCustomRender;
